<template>
  <div>
    <template v-if="tab ===2">
      <log-table :logs="contactHistorys" height="100%"/>
    </template>
    <template v-else>
      <v-simple-table class="table-layout custome-style">
        <template v-if="tab < 4 && tab != 1" v-slot:default>
          <thead>
          <tr>
            <th v-show="showSTT">#</th>
            <th>Người thực hiện</th>
            <th v-if="tab == 3">Đơn hàng</th>
            <th>Thời gian</th>
            <th>Mô tả</th>
            <th style="min-width: 70px" v-if="tab == 0">Thao tác</th>
          </tr>
          </thead>
          <tbody
              v-for="(contactHistory, index) in contactHistorys"
              :key="contactHistory.id"
              @click="editAppointment(contactHistory)"
              style="cursor: pointer"
          >
          <tr>
            <td v-show="showSTT">{{ index + 1 }}</td>
            <td>{{ _.get(contactHistory, "creatorFullName", "") }}</td>
            <td v-if="tab == 3">
              {{ _.get(contactHistory, "order.getfly_id", "") }}
            </td>
            <td>
              {{ formatDate(_.get(contactHistory, "createdAt", "")) }}
              {{ formatHour(_.get(contactHistory, "createdAt", "")) }}
            </td>
            <td>
            <span v-if="!contactHistorys[index].editable">{{
                _.get(contactHistory, "description", "")
              }}</span>
              <textarea
                  v-else
                  v-model="contactHistory.description"
                  @change="updateContactHistory(contactHistory)"
                  style="
                width: 100%;
                height: 80%;
                margin-top: 10px;
                padding-left: 5px;
              "
              ></textarea>
            </td>
            <td v-if="tab == 0">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                      size="16"
                      width="20"
                      height="20"
                      class="mr-1"
                      icon
                      small
                      color="primary"
                      v-on="on"
                      @click="showEditForm(contactHistory, index)"
                  >
                    <v-icon size="16">mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>Sửa</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                      :style="
                    checkContactHistory(contactHistory) ? 'display: none' : ''
                  "
                      size="16"
                      width="20"
                      height="20"
                      class="mr-1"
                      icon
                      small
                      color="error"
                      @click="deleteContactHistory(contactHistory)"
                      v-on="on"
                  >
                    <v-icon size="16">mdi-delete</v-icon>
                  </v-btn>
                </template>
                <span>Xóa lịch sử</span>
              </v-tooltip>
            </td>
          </tr>
          </tbody>
        </template>
        <div v-if="tab === 1">
          <validation-observer>
            <v-row style="margin-top: -30px">
              <v-col cols="12" md="12" style="text-align: right">
                <div style="background: #fbfbfb; padding: 23px 24px">
                  <div class="d-flex">
                    <v-btn
                        color="#FF6609"
                        width="131"
                        height="30"
                        style="margin-right: 12px"
                        @click="contactInterviews"
                    >
                      + Lịch phỏng vấn
                    </v-btn>
                    <v-btn
                        v-if="typeId == 6"
                        color="#0180C7"
                        width="94"
                        height="30"
                        class="black--text"
                        style="font-weight: 600; margin-right: 13px; color: #fff!important;"
                        @click="pickNewTest('ieltsy')"
                    >
                      + Trải nghiệm
                    </v-btn>
                    <v-btn
                        color="#F2F2F2"
                        width="94"
                        height="30"
                        class="black--text"
                        style="font-weight: 600; margin-right: 13px"
                        @click="pickNewTest"
                    >
                      + Test online
                    </v-btn>
                    <!--                <v-btn-->
                    <!--                    color="#27AE60"-->
                    <!--                    v-if="typeId == 6"-->
                    <!--                    width="94"-->
                    <!--                    height="30"-->
                    <!--                    class="black&#45;&#45;text"-->
                    <!--                    style="font-weight: 600; margin-right: 13px; color: #fff!important;"-->
                    <!--                    @click="pickNewTest('ieltsy')"-->
                    <!--                >-->
                    <!--                  + TEST OFFLINE-->
                    <!--                </v-btn>-->
                    <v-btn
                        color="#F2F2F2"
                        v-if="typeId == 6"
                        width="94"
                        height="30"
                        class="black--text"
                        style="font-weight: 600; margin-right: 13px"
                        @click="pickNewTrial"
                    >
                      + HỌC THỬ
                    </v-btn>
                  </div>
                  <!--              <validation-provider v-slot="{ errors }" name="Thông tin ghi chú">-->
                  <!--                <v-text-field-->
                  <!--                    label="Note"-->
                  <!--                    rows="3"-->
                  <!--                    class="tab-note"-->
                  <!--                    v-model="note"-->
                  <!--                    @keydown.enter.exact.prevent="-->
                  <!--                    handleSubmit(clickCreateHistoryContact())-->
                  <!--                  "-->
                  <!--                    :error-messages="errors"-->
                  <!--                />-->
                  <!--              </validation-provider>-->
                </div>
                <div>
                  <div
                      class="d-flex justify-space-between align-center book-calendar"
                  >
                    <h4 class="pt-2 pl-3" style="color: #333333; font-size: 12px">
                      Danh sách lịch hẹn ({{
                        sheduleInfo ? sheduleInfo.length : 0
                      }})
                    </h4>
                    <div style="margin-right: 14px">
                      <v-icon
                          @click="toggleBlock()"
                          :class="`rotate block-rotate`"
                      >mdi-chevron-down
                      </v-icon
                      >
                    </div>
                  </div>
                  <div :class="`block-section block-schedule`">
                    <div
                        :class="`block-booking align-center  ${index < blockToShow ? 'd-flex' : 'd-none'} justify-space-between`"
                        v-for="(schedule,index) in sheduleInfo" :key="index"
                    >
                      <div class="block-left d-flex">
                        <img
                            v-if="schedule.subjectId == 1 && schedule.curriculum == 'TOAN_THPT'"
                            class="icon-tab"
                            src="@/assets/operational/toan.jpg"
                            alt=""
                        />
                        <img
                            v-else-if="schedule.subjectId == 4"
                            class="icon-tab"
                            src="@/assets/operational/ly.jpg"
                            alt=""
                        />
                        <img
                            v-else-if="schedule.subjectId == 5"
                            class="icon-tab"
                            src="@/assets/operational/hoa.jpg"
                            alt=""
                        />
                        <img
                            v-else-if="schedule.subjectId == 6"
                            class="icon-tab"
                            src="@/assets/operational/sinh.jpg"
                            alt=""
                        />
                        <img
                            v-else-if="schedule.subjectId == dhqghn"
                            class="icon-tab"
                            src="@/assets/operational/dhqghn.jpg"
                            alt=""
                        />
                        <img
                            v-else-if="schedule.subjectId == dhqgtphcm"
                            class="icon-tab"
                            src="@/assets/operational/dhqgtphcm.jpg"
                            alt=""
                        />
                        <img
                            v-else-if="schedule.subjectId == dhbk"
                            class="icon-tab"
                            src="@/assets/operational/bk.jpg"
                            alt=""
                        />
                        <img
                            v-else-if="schedule.subjectId == 1"
                            class="icon-tab"
                            src="@/assets/operational/math.jpg"
                            alt=""
                        />
                        <img
                            v-else-if="schedule.subjectId === 3 && schedule.curriculum == TYPE_SUBJECT_IELTS_TEST"
                            class="icon-tab"
                            src="@/assets/operational/ielts_logo.jpg"
                            alt=""
                        />
                        <img
                            v-else-if="schedule.subjectId === 3"
                            class="icon-tab"
                            src="@/assets/operational/eng.jpg"
                            alt=""
                        />
                        <img
                          v-else-if="schedule.subjectId === KHTN"
                          class="icon-tab"
                          src="@/assets/operational/khtn_icon.svg"
                          alt=""
                        />
                        <img
                            v-else-if="schedule.type === 'trial'"
                            class="icon-tab"
                            src="@/assets/operational/eng.jpg"
                            alt=""
                        />
                        <div class="d-flex flex-column align-start">
                      <span v-if="schedule.status && schedule.status.value != 0 && schedule.type == 'trial'" class="booking-time">
                        {{ schedule.interviewDateAt ? `${schedule.interviewDateAt}`  : '' }} {{schedule.curriculumName ? ` - ${schedule.curriculumName}` : ''}} {{schedule.fullName ? ` - ${schedule.fullName}` : ''}}
                      </span>
                          <span class="booking-time" v-else-if="schedule.status && schedule.status.value != 0"
                          >{{ schedule.interviewDateAt ? `${schedule.interviewDateAt},`  : '' }} {{ schedule.fromTime ? schedule.fromTime : '' }}
                        {{ schedule.toTime ? `-${schedule.toTime}` : '' }} {{schedule.curriculumName ? ` - ${schedule.curriculumName}` : ''}} {{schedule.fullName ? ` - ${schedule.fullName}` : ''}}</span
                          >
                          <span v-else class="booking-time"></span>
                          <span v-if="schedule.operationType" class="booking-type d-flex align-center">{{
                              schedule.operationType.text
                            }} <span class="ml-1" v-if="curriculumTHPT.includes(schedule.curriculumId) && [tutorStatus.haveResult, tutorStatus.payRoute].includes(schedule.status.value) && schedule.source">| {{schedule.source}}</span>
                        <v-chip
                            class="ma-2"
                            :color="schedule.color"
                            :data-color="schedule.color"
                            text-color="white"
                            :style="`background: ${schedule.color}`"
                            style="font-size:10px"
                            x-small>
                          {{schedule.statusName}}
                        </v-chip>
                        <v-chip
                            v-if="schedule.learning_status"
                            class="ma-2"
                            :color="schedule.learning_status.color"
                            :data-color="schedule.learning_status.color"
                            text-color="white"
                            :style="`background: ${schedule.learning_status.color}`"
                            style="font-size:10px"
                            x-small>
                          {{schedule.learning_status.text}}
                        </v-chip>

                        <div class="level-sort" v-if="schedule.studentLevel != null" style="width: 130px;">
                            {{getLevelStudent(schedule.studentLevel)}}<template v-if="schedule.subLevel != null">{{schedule.subLevel == 1 ? 'A' : schedule.subLevel == 2 ? 'B' : schedule.subLevel == 3 ? 'C' : ''}}</template>
                        </div>
                      </span>
                        </div>
                      </div>
                      <div class="block-right d-flex align-center">
                        <v-btn
                            v-if="
                          schedule.statusLink &&
                          ([TOAN_ERP, KHTN].includes(schedule.subjectId) || schedule.curriculumId === TA_SGK) &&
                          schedule.status &&
                         ([tutorStatus.payRoute, tutorStatus.tested].includes(schedule.status.value)) &&
                         schedule.operationType &&
                         (schedule.operationType.value == 1)
                      "
                            height="32"
                            width="32"
                            icon
                            :href="schedule.statusLink" target="_blank"
                        >
                          <v-icon style="font-size: 22px" color="blue">mdi-link</v-icon>
                        </v-btn>
                        <v-btn icon v-if="  schedule.status && schedule.type != 'trial' &&
                          (schedule.status.value == tutorStatus.testBooked ||
                          schedule.status.value == tutorStatus.waitForSeat ||
                          schedule.status.value == tutorStatus.startTest ||
                          schedule.status.value == tutorStatus.booked)"
                               @click="rePick(schedule)"
                               height="24"
                               width="24"
                        >
                          <img

                              src="@/assets/operational/calendar-triage.png"
                              alt=""
                          />
                        </v-btn>
                        <v-btn icon
                               v-if="schedule.status &&
                            (schedule.status.value == tutorStatus.interviewed || schedule.status.value == tutorStatus.tested || schedule.status.value == tutorStatus.payRoute) &&
                            (schedule.operationType && schedule.operationType.value == 2) &&
                            schedule.subjectId == 3 &&
                            !schedule.videoLink"
                               height="24"
                               width="24">
                          <img
                              src="@/assets/operational/PlayCircleBlack.png"
                              alt=""
                          />
                        </v-btn>
                        <v-btn icon
                               height="24"
                               width="24"
                               :href="schedule.videoLink" target="_blank"
                               v-if="schedule.status &&
                           (schedule.operationType && schedule.operationType.value == 2) &&
                           (schedule.status.value == tutorStatus.interviewed || schedule.status.value == tutorStatus.tested || schedule.status.value == tutorStatus.payRoute) &&
                           schedule.subjectId == 3 &&
                           schedule.videoLink"
                        >
                          <img
                              src="@/assets/operational/PlayCircle.png"
                              alt=""
                          />
                        </v-btn>
                        <v-btn icon v-if="(!schedule.appointmentLink && !schedule.learningPathLink) && schedule.status &&
                           (schedule.status.value == tutorStatus.tested || schedule.status.value == tutorStatus.interviewed ||  schedule.status.value == tutorStatus.payRoute)"
                               height="24"
                               width="24">
                          <img
                              src="@/assets/operational/file.png"
                              alt=""
                          />
                        </v-btn>
                        <v-btn icon v-if="schedule.appointmentLink && (schedule.status.value == tutorStatus.tested || schedule.status.value == tutorStatus.interviewed ||  schedule.status.value == tutorStatus.payRoute || (schedule.type == 'trial' && schedule.status.value == tutorStatus.trialComplete)
                    || (curriculumTHPT.includes(schedule.curriculumId)) || schedule.status.value == tutorStatus.haveResult)"
                               :href="schedule.appointmentLink" target="_blank"
                               height="24"
                               width="24">
                          <img
                              src="@/assets/operational/file-color.png"
                              alt=""
                          />
                        </v-btn>
                        <v-btn
                            icon
                            height="32"
                            width="32"
                            v-if="schedule.learningPathLink && (schedule.status.value == tutorStatus.tested || schedule.status.value == tutorStatus.interviewed || schedule.status.value == tutorStatus.payRoute)" :href="schedule.learningPathLink" target="_blank">
                          <img
                              src="@/assets/operational/file-color.png"
                              alt=""
                          />
                        </v-btn>
                        <v-btn icon
                               @click="cancelInterview(schedule)"
                               v-if="schedule.status && schedule.type != 'trial' &&
                          (schedule.status.value == tutorStatus.testBooked ||
                          schedule.status.value == tutorStatus.waitForSeat ||
                          schedule.status.value == tutorStatus.booked ||
                          (schedule.status.value == tutorStatus.haveResult && schedule.curriculumId == CT_TOAN_TAI_NANG && getLevelFromTestLink(schedule.testLink) == 3 && [4,6,7].includes(schedule.gradeId))
                          )"
                               height="24"
                               width="24"
                        >
                          <img
                              class=""
                              style="vertical-align: middle;"
                              src="@/assets/operational/trash.png"
                              alt=""
                          />
                        </v-btn>

                        <v-btn icon
                               height="24"
                               width="24"
                               class="mx-1"
                               v-if="schedule.learning_status && schedule.homeworks"
                               @click="showLinkBTVN(schedule.id)"
                        >
                          <strong style="position: relative;margin: 0px;color:#3785EE">BTVN</strong>
                          <ul class="dropdown-content" v-if="showlink === schedule.id" id="style-1">
                            <li v-for="(item,index) in schedule.homeworks" :key="'btvn'+index"><a :href="item.result_link" target="_blank" >LINK {{index + 1}}</a></li>
                          </ul>
                        </v-btn>

                        <!-- <img v-if="book.operationType.value == 1" class="icon"
                          src="@/assets/operational/file.png" alt=""> -->
                        <span @click="deleteTicketTrial(schedule)" style="cursor:pointer" v-if="['Chờ xác nhận','Xác nhận'].includes(schedule.statusName)" size="large"><img
                            class="icon mr-0"
                            src="@/assets/operational/trash.png"
                            alt=""
                        /></span>
                        <v-menu offset-y>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-if="schedule.status && (schedule.status.value === tutorStatus.cancel || schedule.status.value === tutorStatus.fail)" v-bind="attrs" v-on="on"
                            >mdi-dots-horizontal</v-icon
                            >
                          </template>
                          <v-list dense v-if="schedule.status && (schedule.status.value === tutorStatus.accepted || schedule.status.value === tutorStatus.confirmFirst)">
                            <v-list-item @click="rePick(schedule)">
                              <img
                                  class="icon"
                                  src="@/assets/operational/calendar-triage.png"
                                  alt=""
                              />Sửa
                            </v-list-item>
                            <v-list-item  @click="cancelInterview(schedule)">
                              <img
                                  class="icon"
                                  src="@/assets/operational/trash.png"
                                  alt=""
                              />Hủy
                            </v-list-item>
                          </v-list>
                          <v-list dense v-if="schedule.status && (schedule.status.value === tutorStatus.cancel || schedule.status.value === tutorStatus.fail)">
                            <v-list-item @click="rePickSchedule(schedule)">
                              <img
                                  class="mr-4"
                                  src="@/assets/operational/calendar-triage.png"
                                  alt=""
                              />Chọn lại lịch
                            </v-list-item>
                          </v-list>
                        </v-menu>
                        <v-text-field
                            placeholder="Note"
                            rows="3"
                            class="ml-3 create-note"
                            style="margin-bottom:10px"
                            v-model="schedule.note"
                            @keydown.enter.exact.prevent="clickCreateHistoryContact(schedule)"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </v-col>
              <v-simple-table class="table-layout table-overflow" style="width: 100%">
                <template v-slot:default>
                  <thead>
                  <tr>
                    <th>User</th>
                    <th>Thời gian</th>
                    <th style="width: 200px;">Mô tả</th>
                    <th style="width: 70px">Thao tác</th>
                  </tr>
                  </thead>
                  <tbody
                      v-for="(contactHistory, index) in tutorNoteHistory"
                      :key="contactHistory.id"
                      @click="editAppointment(contactHistory)"
                      style="cursor: pointer"
                  >
                  <tr>
                    <td>{{ contactHistory.creator.fullName }}</td>
                    <td>
                      {{contactHistory.createdAt}}
                    </td>
                    <td>
                      <a
                          v-if="!tutorNoteHistory[index].editable"
                          :href="filterLink(contactHistory.description)"
                          :target="regexUrl.test(contactHistory.description) ? '_blank' : false"
                          style="text-decoration: unset;color: #333"
                      ><span style="color: blue;text-decoration: underline">{{filterLink(contactHistory.description)}}</span>

                        {{checkUrlDescription(_.get(contactHistory, "description", ""))}}</a>
                      <textarea
                          v-else
                          v-model="contactHistory.description"
                          @change="updateContactHistory(contactHistory,index)"
                          style="
                        width: 100%;
                        height: 80%;
                        margin-top: 10px;
                        padding-left: 5px;
                      "
                    ></textarea>
                  </td>
                  <td>
                    <v-tooltip
                      bottom
                      v-if="user.id === contactHistory.createdBy"
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn
                          size="16"
                          width="20"
                          height="20"
                          class="mr-1"
                          icon
                          small
                          color="primary"
                          v-on="on"
                          @click="showEditForm(contactHistory, index)"
                        >
                          <v-icon size="16">mdi-pencil</v-icon>
                        </v-btn>
                      </template>
                      <span>Sửa</span>
                    </v-tooltip>
                    <v-tooltip bottom v-if="user.id === contactHistory.createdBy">
                      <template v-slot:activator="{ on }">
                        <v-btn
                            size="16"
                            width="20"
                            height="20"
                            class="mr-1"
                            icon
                            small
                            color="error"
                            @click="deleteContactHistory(contactHistory)"
                            v-on="on"
                        >
                          <v-icon size="16">mdi-delete</v-icon>
                        </v-btn>
                      </template>
                      <span>Xóa lịch sử</span>
                    </v-tooltip>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-row>
      </validation-observer>
    </div>
    <div v-if="tab === 4"  style="overflow: auto">
     <OrderHistory 
        projectName="CRM"
        :totalListOrder="totalListOrder"
        :urlCRM="urlCRM"
        :urlERP="urlERP"
        :urlOMS="urlOMS"
        @redirectOrder="handleRedirectOrder($event)" 
        @toOrderDetail="toOrderDetail($event)" 
        @openDetailOrder="openDetailOrder($event)"
        @openDetailOrderGroup="openDetailOrderGroup($event)"
      />
    </div>
    <v-dialog
        v-if="pickTest"
        v-model="pickTest"
        persistent
        max-width="900px"
        :retain-focus="false"
    >
      <PickTest
          :contact="contactQuickviewDetail"
          @close="pickTest = false"
          :book="book"
          :curriculums="curriculums"
          :typeId="typeId"
          :isIeltsy="isIeltsy"
          :schoolLevelId="schoolLevelId"
          v-if="pickTest"
      />
    </v-dialog>
    <v-dialog v-model="pickDate" max-width="900"  :retain-focus="false"  @click:outside="closeDialog">
      <PickDatePopup v-if="pickDate"  :curriculums="curriculums" :interviewDetailId="interviewDetailId" :isCancel="isCancel" :contacts="contactQuickviewDetail" :book="book" />
    </v-dialog>
    <v-dialog v-model="pickTrial" max-width="1100" :retain-focus="false">
      <PickTrial :closePickTrial="closePickTrial" v-if="pickTrial" :curriculums="curriculums" :contactQuickviewDetail="contactQuickviewDetail" @setTrialSuccess="setTrialSuccess()" />
    </v-dialog>
    <div v-if="tab==5">
      <thead>
        <tr>
          <th class="sticky-left">Người tạo</th>
          <th>Ngày tạo</th>
          <th>Nhóm ticket</th>
          <th>Loại ticket</th>
          <th>Trạng thái xử lý</th>
          <th class="sticky-right">Thao tác</th>
        </tr>
      </thead>
      <tbody
        v-for="(contactHistory, index) in requestList"
        :key="contactHistory.id"
        @click="editAppointment(contactHistory)"
        style="cursor: pointer"
        class="history-support"
      >
        <tr>
          <td class="sticky-left">{{ contactHistory.createdBy.username }}</td>
          <td class="text-center">{{ formatDateCustom(contactHistory.createdAt) || "_" }}</td>
          <td class="text-left">{{ contactHistory.template.groupTicketName || "_" }}</td>
          <td class="text-left">{{ contactHistory.template.typeTicketName || "_" }}</td>
          <td class="text-center justify-center d-flex">
            <div
                class="ticket-status-box"
                v-if="contactHistory.status && contactHistory.status.name"
                :style="`background: ${listTicketStatus.some((e) => e.value === contactHistory.status.name) ? listTicketStatus.find((e) => e.value === contactHistory.status.name).color : '#000000'}`"
                style="color: white">
              {{ contactHistory.status.name}}
            </div>
            <div v-else>
              _
            </div>
          </td>
          <td class="text-center sticky-right">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  size="16"
                  width="20"
                  height="20"
                  class="mr-1"
                  icon
                  small
                  color="#456EFF"
                  v-on="on"
                  @click="showEditFormSupport(contactHistory, index)"
                >
                  <v-icon size="16">mdi-information</v-icon>
                </v-btn>
              </template>
              <span>Thông tin chi tiết</span>
            </v-tooltip>
          </td>
        </tr>
      </tbody>
      <tbody v-if="requestList.length <= 0">
        <tr>
          <td colspan="100">
            <common-no-result />
          </td>
        </tr>
      </tbody>
    </div>
    <div v-if="tab ==5">
      <div class="pb-3">
      <v-col
        cols="12"
        md="12"
        class="pb-0 pa-0"
        style="display: flex; justify-content: flex-end; padding: 0 12px"
      >
        <div class="text-right mb-1 mt-2 ml-4 sticky-right">
          {{ showIndex() }}
          <v-btn
            small
            class="pagination-btn-left"
            @click="
              () => {
                currentPage--;
              }
            "
                    :disabled="currentPage == 1"
                >
                  <v-icon>mdi-menu-left</v-icon>
                </v-btn>
                <v-btn
                    :disabled="totalItemRequestList <= currentPage*limit"
                    small
                    class="pagination-btn-right"
                    @click="
              () => {
                currentPage++;
              }
            "
                >
                  <v-icon>mdi-menu-right</v-icon>
                </v-btn>
              </div>
            </v-col>
          </div>
        </div>
      </v-simple-table>
    </template>
  </div>
</template>
<script>
import TicketRepository from "@/repositories/TicketRepository";
const regexUrl = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/;
import {
  tutorStatus,
  levelEnglish,
  LevelMath,
  SUBJECTS_SORT_CLASS,
  LOAI_GIAOVIEN,
  PACKAGE_FEE,
  namesOrderContactStatusTc,
  ORDER_FINISH_TYPE, ORDER_DEPOSIT_TYPE,
  TYPE_SUBJECT_IELTS_TEST,
  dhqghn, dhqgtphcm, dhbk, curriculumTHPT, CT_TOAN_TAI_NANG,
  ORDER_RECEIPT_STATUS_MAP,
  ORDER_VERSION,
  PRODUCT_TRIAL_TYPE,
  KHTN, TA_SGK, TOAN_ERP
} from "../../../helpers/constants";
import RepositoryFactory from "../../../repositories/RepositoryFactory";
const TutorTestRepository = RepositoryFactory.get("tutorTest");
import PickTest from "./ModalPickTest";
import PickDatePopup from "./ModalPickDate";
import PickTrial from "./ModalPickTrial";
import TokenService from "../../../helpers/token";
const SupportRepository = RepositoryFactory.get('support')
import * as moment from 'moment'
import OrderHistory from 'vh-sub-modules/ShareModules/src/components/OrderHistory'
import LogTable from "../../../../vh-sub-modules/ShareModules/src/components/log/LogTable.vue";
export default {
  components:{
    LogTable,
    PickTest,
    PickDatePopup,
    PickTrial,
    OrderHistory
  },
  props: {
    contactQuickviewDetail:{
    },
    contactHistorys: {
      type: Array,
      default: () => [],
    },
    showSTT: {
      type: Boolean,
      default: true,
    },
    currentUserId: {
      type: String,
      default: "",
    },
    tab: {
      type: Number,
      default: 0,
    },
    orderList: {
      type: Array,
      default: () => [],
    },
    sheduleInfo: {
      type: Array,
      default: () => [],
    },
    tutorNoteHistory: {
      type: Array,
      default: () => [],
    },
    filterForm: {
      default: () => ({})
    },
    listTransferOrder: {
      type: Array,
      default: () => [],
    },
    totalListOrder: {
      type: Array,
      default: () => [],
    },
    curriculums: {
      type: Array,
      default: () => [],
    },
    typeId: {
      type: Number,
      default: () => null,
    },
    schoolLevelId: {
      type: Number,
      default: () => null,
    },
  },
  data(){
    return{
      TA_SGK,
      TOAN_ERP,
      urlCRM: process.env.VUE_APP_API,
      urlERP: process.env.VUE_APP_SORT_CLASS,
      urlOMS: process.env.VUE_APP_API_OMS,
      PRODUCT_TRIAL_TYPE,
      ORDER_VERSION,
      KHTN,
      listTicketStatus: [],
      showlink: false,
      pickTest: false,
      pickDate: false,
      user: null,
      note: null,
      drawn: false,
      isCancel:false,
      interviewDetailId:null,
      book:null,
      tutorStatus,
      blockToShow:2,
      regexUrl,
      levelEnglish,
      LevelMath,
      SUBJECTS_SORT_CLASS,
      LOAI_GIAOVIEN,
      PACKAGE_FEE,
      ORDER_RECEIPT_STATUS_MAP,
      statusTcNames: namesOrderContactStatusTc,
      orderFinishType: ORDER_FINISH_TYPE,
      orderDepositType: ORDER_DEPOSIT_TYPE,
      TYPE_SUBJECT_IELTS_TEST,
      isIeltsy: false,
      pickTrial: false,
      requestList:[],
      currentPage: 1,
      limit:10,
      totalItemRequestList:0,
      totalPageRequestList:0,
      dhqghn,
      dhqgtphcm,
      dhbk,
      curriculumTHPT,
      CT_TOAN_TAI_NANG,
    }
  },
  watch: {
        currentPage: {
            handler() {
                this.getListSupportV2()
            }
        }
    },
  computed: {
    innerWidth() {
      return window.innerWidth;
    },
  },
  async created() {
    this.user = TokenService.getUser();
    Bus.$on("close-modal-test", () => {
      this.pickTest = false;
      this.isIeltsy = false;
    });
    Bus.$on('close-modal-pick',()=>{
      this.pickDate = false;
      this.book = null;
    })
    Bus.$off("reload-tab-tutor")
    // Bus.$on('reload-tab-tutor',()=>{
    //     this.getInterviewsDetail()
    // })
    Bus.$off("note-pick-date")
    Bus.$on('note-pick-date', async (data)=>{
      let body = {
        description: _.trim(data.note),
        action: "OPERATION",
        contactId: data.contactId,
        contactTutorPracticeId:data.contactTutorPracticeId
      };
      const res = await TutorTestRepository.createNote(
          data.contactId,
          body
      );
      Bus.$emit('reload-interview')
      this.getNote()
      this.pickDate = false
    })
    if(this.tab == 5 ){
      await this.getListStatusTicket()
      await this.getListSupportV2()
    }
  },
  beforeDestroy(){
    Bus.$off('close-modal-pick')
    Bus.$off('close-modal-test');
  },
  methods: {
    handleRedirectOrder(order) {
      let routeData = this.$router.resolve({name: 'OrderDetailNew', params: { id: order.contactId}, query: {order: order.id},})
      window.open(routeData.href, '_blank')
    },
    async getListStatusTicket() {
      const response = await TicketRepository.getListTicketStatus()
      if (response.success) {
        this.listTicketStatus = response.data;
      }
    },
    formatDateCustom(value){
      if(value){
        return moment(value).format('DD/MM/YYYY')
      }
      return ''
    },
    showIndex() {
        if (this.requestList.length > 0) {
          let maxIndex = this.requestList.length < this.limit ? parseInt(this.currentPage - 1) * parseInt(this.limit) + this.requestList.length : parseInt(this.currentPage) * parseInt(this.limit)
          return this.requestList.length < this.limit ? (maxIndex - parseInt(this.requestList.length) + 1) + ' - ' + maxIndex : (maxIndex - parseInt(this.limit) + 1) + ' - ' + maxIndex
        } else {
          return ('0 - 0')
        }
      },
    async getListSupportV2(){
          const params = {
            "customerCode": this.contactQuickviewDetail.code,
            limit: this.limit,
            page: this.currentPage,
            systemId: 1,
          };
          const loading = this.$loading.show()
          let res = await SupportRepository.getListSupportsV3(params);
          if (res.success) {
            this.requestList = _.get(res, "data", []);
            this.totalItemRequestList = _.get(res, "totalItem", 0 );
          } else {
            this.requestList = [];
          }
          loading.hide()
    },
    deleteTicketTrial(schedule) {
      this.$swal({
        title: "Bạn chắc chắn muốn huỷ lịch học thử ?",
        confirmButtonText: "Đồng ý",
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "Hủy bỏ",
      }).then(async (result) => {
        if (result.value) {
          let res = await TutorTestRepository.deleteTicketTrial(schedule.id);
          if (res.success) {
            this.$swal({
              title: "Huỷ thành công",
              confirmButtonText: "Đồng ý",
            }).then(() => {
              Bus.$emit("reload-interview");
            });
          } else {
            this.$swal({
              type: "error",
              title: "Lỗi !",
              text: _.get(res, "message", ""),
            });
          }
        }
      });
    },
    editAppointment(contactHistory) {
      if (
        contactHistory.action === "APPOINTMENT" &&
        contactHistory.dataId != null
      ) {
        Bus.$emit("appointment-show-form-from-appointment", {
          id: contactHistory.dataId,
        });
      }
    },
    deleteContactHistory(contactHistory) {
      if(this.tab == 1){
        this.$swal({
          title: 'Xóa lịch sử',
          text: 'Bạn có thực sự chắc chắn ?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Đồng ý',
          cancelButtonText: 'Hủy bỏ',
        }).then(async (result) => {
          if (result.value) {
            // const loader = this.$loading.show()
            let res = await TutorTestRepository.deleteContactHistory(contactHistory.id)
            // loader.hide()
            if (res.success) {
              this.$swal({
                    title: 'Xóa thành công !',
                    confirmButtonText: 'Đồng ý',
                  },
              ).then(() => {
                Bus.$emit("reload-contactHistory", contactHistory);
              })
            } else {
              this.$swal({
                type: 'error',
                title: 'Lỗi !',
                text: _.get(res, 'message', ''),
              })
            }
          }
        })
      }
      else{
        this.$emit('deleteContactHistory', contactHistory)
      }
    },
    checkContactHistory(contactHistory) {
      if (
        contactHistory.action === "NOTE" &&
        contactHistory.createdBy == this.currentUserId
      ) {
        return false;
      }
      return true;
    },
    showEditForm(contactHistory, index) {
      this.editDesc = _.get(contactHistory, "description", "");
      if(this.tab == 1) {
        this.tutorNoteHistory[index].editable = true;
      } else {
        this.contactHistorys[index].editable = true;
      }
    },
    showEditFormSupport(contactHistory, index) {
      const routeData =  this.$router.resolve({
        path: '/customer-support-v2',
        query: {
          tab:1,
          createdBy: contactHistory.createdBy.username,
          createdAt: contactHistory.createdAt,
          nameCode: this.contactQuickviewDetail.code,
        }
      });
      window.open(routeData.href, '_blank');
    },
    async updateContactHistory(contactHistory,index) {
      if(this.tab == 1){
        // const loader = this.$loading.show();
        const body = {
          contactTutorPracticeId:this.contactQuickviewDetail.id,
          action:'OPERATION'
        }
        if (this.notePickDate) {
          body.description = this.notePickDate
          const res = await TutorTestRepository.updateNote(contactHistory.id, body);
          this.notePickDate = null
        } else {
          body.description = contactHistory.description
          const res = await TutorTestRepository.updateNote(contactHistory.id, body);
        }
        this.tutorNoteHistory[index].editable = false
        this.$emit("reload-contactHistory", contactHistory);
        // loader.hide();
        // this.getNote();
      }
      else{
        this.$emit('updateContactHistory', contactHistory)
      }
    },
    async clickCreateHistoryContact(schedule) {
      if (_.trim(schedule.note) == "") {
        return;
      }
      let body = {
        description: _.trim(schedule.note),
        action: "OPERATION",
        contactId: this.contactQuickviewDetail.id,
        contactTutorPracticeId: schedule?.type == 'trial' ? 999998 :  schedule.id
      };
      const loader = this.$loading.show();
      const res = await TutorTestRepository.createNote(
          this.contactQuickviewDetail.id,
          body
      );
      loader.hide();
      if (res.error) {
        this.errorMessage = _.get(response, "message", "");
        this.$swal({
          type: "error",
          title: "Lỗi !",
          text: this.errorMessage,
        }).then(() => {});
        return;
      }
      this.note = "";
      Bus.$emit('reload-interview')
    },
    contactInterviews() {
      (this.pickDate = true), (this.contactId = this.contactQuickviewDetail.id);
      //this.customerId = this.contacts.customerId;
      this.isCancel = true
      Bus.$emit('reload-schedule-date-time')
    },
    closeEdit() {
      this.drawn = false;
    },
    // editAppointment(contactHistory) {
    //   if (
    //       contactHistory.action === "APPOINTMENT" &&
    //       contactHistory.dataId != null
    //   ) {
    //     Bus.$emit("appointment-show-form-from-appointment", {
    //       id: contactHistory.dataId,
    //     });
    //   }
    // },
    // deleteContactHistory(contactHistory) {
    //   this.$swal({
    //     title: 'Xóa lịch sử',
    //     text: 'Bạn có thực sự chắc chắn ?',
    //     type: 'warning',
    //     showCancelButton: true,
    //     confirmButtonText: 'Đồng ý',
    //     cancelButtonText: 'Hủy bỏ',
    //   }).then(async (result) => {
    //     if (result.value) {
    //       // const loader = this.$loading.show()
    //       let res = await TutorTestRepository.deleteContactHistory(contactHistory.id)
    //       // loader.hide()
    //       if (res.success) {
    //         this.$swal({
    //               title: 'Xóa thành công !',
    //               confirmButtonText: 'Đồng ý',
    //             },
    //         ).then(() => {
    //           this.getNote()
    //         })
    //       } else {
    //         this.$swal({
    //           type: 'error',
    //           title: 'Lỗi !',
    //           text: _.get(res, 'message', ''),
    //         })
    //       }
    //     }
    //   })
    // },
    //
    // checkContactHistory(contactHistory) {
    //   if (contactHistory.action === "NOTE") {
    //     return false;
    //   }
    //   return true;
    // },
    // showEditForm(contactHistory, index) {
    //   this.editDesc = _.get(contactHistory, "description", "");
    //   this.contactHistorys[index].editable = true;
    // },
    // async updateContactHistory(contactHistory) {
    //   const loader = this.$loading.show();
    //   if (this.notePickDate){
    //     const res = await TutorTestRepository.updateNote(contactHistory.id, {
    //       description: this.notePickDate,
    //     });
    //     this.notePickDate = null
    //   }
    //   else{
    //     const res = await TutorTestRepository.updateNote(contactHistory.id, {
    //       description: contactHistory.description,
    //     });
    //   }
    //   this.$emit("updateContactHistory", contactHistory);
    //   loader.hide();
    //   this.getNote();
    // },
    async comfirmBook(id) {
      let res = await TutorTestRepository.confirmInterview(id);
      if (res.success) {
        this.$swal({
          title: "Xác nhận thành công",
          type: "success",
        }).then(() => {
          Bus.$emit('reload-interview')
        });
      } else {
        this.$swal({
          title: "Có lỗi xảy ra!",
          type: "error",
        });
      }
    },
    cancelInterview(book) {
      this.$swal({
        title: "Bạn chắc chắn hủy lịch phỏng vấn ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Đồng ý",
        cancelButtonText: "Hủy",
      }).then(async (result) => {
        if (result.value) {
          let res
          if(book.operationType.value == 1 || book.operationType.value == 3 || book.operationType.value == 5){
            res =  await TutorTestRepository.cancelTest(book.id)
          }
          else{
            res = await TutorTestRepository.cancelInterview(book.id);
          }
          if (res.data.success) {
            this.$swal({
              title: "Hủy thành công",
              type: "success",
            }).then(() => {
              Bus.$emit('reload-interview')
            });
          } else {
            this.$swal({
              title: "Có lỗi xảy ra",
              type: "error",
            });
          }
        }
      });
    },
    toggleBlock() {
      if(this.blockToShow == 99){
        this.blockToShow = 2
      }
      else{
        this.blockToShow = 99
      }
      $(`.rotate`).toggleClass("down");
    },
    rePickSchedule(book){
      this.book = book
      this.isCancel = true
      this.interviewDetailId = book.id
      if(book.operationType.value === 2){
        this.pickDate = true
      }
      if(book.operationType.value === 1){
        this.pickTest = true
      }
      Bus.$emit('reload-schedule-date-time')
    },
    rePick(book){
      console.log("book:", book)
      if(book?.operationType?.value == 1){
        this.pickTest = true
        if (book.status.value == this.tutorStatus.waitForSeat){
          this.checkWaitStatus = true
          this.$store.commit('CHECK_STATUS_QUICKVIEW',this.checkWaitStatus)
        }
      }
      if(book?.operationType?.value == 2){
        this.pickDate = true
      }
      if(book?.operationType?.value == 3 || book?.operationType?.value == 5){
        this.pickTest = true;
        this.isIeltsy = true;
      }
      this.isCancel = false
      this.interviewDetailId = book.id
      this.book = book
      this.isCancel = false
      Bus.$emit('reload-schedule-date-time')
    },
    closeDialog() {
      Bus.$emit('closeDialog')
    },
    pickNewTest(value = null){
      this.pickTest = true;
      this.book = null;
      if (value == 'ieltsy') {
        this.isIeltsy = true;
      } else {
        this.isIeltsy = false;
      }
      Bus.$emit('reset-value-test')
    },
    filterLink(link){
      let urlLink,
          regexUrl = this.regexUrl
      link.replace(this.regexUrl,function(url){
        if (regexUrl.test(link)){
          urlLink = url
        }
        else {
          urlLink = 'javascript:void(0)'
        }
      })
      return urlLink

    },
    checkUrlDescription(link) {
      let linkReturn = link.replace(this.filterLink(link),' ')
      linkReturn = linkReturn.replace(/(<([^>]+)>)/ig, "");
      return linkReturn
    },
    getLevelStudent(levelStudent) {
      if (levelStudent == null) return;
      const levels = [...this.$store.state.LEVEL_MATH, ...this.$store.state.LEVEL_ENGLISH, ...this.$store.state.LEVEL_KHTN];
      return levels.find(level => level.id == levelStudent)?.name || '';
    },
    subjectTransfer(id) {
        let subject
        SUBJECTS_SORT_CLASS.map((s) => {
                if(s.id == id) {
                    return subject = s.name
                }
        })
        return subject
    },
    typeTeacher(id) {
        let typeTeacher
        LOAI_GIAOVIEN.map((s) => {
                if(s.id == id) {
                    return typeTeacher = s.name
                }
        })
        return typeTeacher
    },
    toOrderDetail(id) {
      if (!id) {
        return
      }
      let routeData = this.$router.resolve({
        name: 'OrderDetail',
        params: {
          id
        },
        query: {
          codeOrder: 2,
        },
      })
      window.open(routeData.href, '_blank')
    },
    pickNewTrial() {
      this.pickTrial = true;
    },
    closePickTrial() {
      this.pickTrial = false;
    },
    setTrialSuccess() {
      this.$emit('setTrialSuccess')
    },
    showLinkBTVN(id) {
      this.showlink = this.showlink === id ? null : id
    },
    getLevelFromTestLink(link) {
      const regex = /[?&]level=(\d+)/;
      const match = link.match(regex);
      const level = match ? match[1] : null;

      return level;
    },
    openDetailOrder(order) {
      if (order.version === this.ORDER_VERSION.V1) {
        const routeData = this.$router.resolve({name: 'OrderDetail', params: { id: order.id}, query: {orderList: true}});
        window.open(routeData.href, '_blank');
      } else {
        let routeData = this.$router.resolve({name: 'OrderDetailNew', params: { id: order.contactId}, query: {order: order.id},})
        window.open(routeData.href, '_blank')
      }
    },
    openDetailOrderGroup(order) {
      const id = order.listOrders.find(item => item.code === order.code)
      const routeData = this.$router.resolve({name: 'OrderDetail', params: { id: id.id}, query: {orderList: true}});
      window.open(routeData.href, '_blank');
    },
  },
};
</script>
<style lang="scss" scoped>

.dropdown-content {
  top:16px;
  left: 0px;
  border-radius: 5px;
  position: absolute;
  background-color: #f9f9f9;
  width: fit-content;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  border: 1px solid #999999;
  z-index: 30;
  max-height: 150px;
  overflow-y: auto;
  li {
    padding: 10px 0px;
    margin: 0px 15px;
    border-bottom: 1px solid #CBD4DB ;
    a {
      color: #2F80ED;
      font-family: Roboto;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      text-decoration: none;
    }
  }
  li:last-of-type {
    border: none;
  }
}

.table-layout .v-data-table__wrapper thead th {
  position: sticky;
  top: 0px;
  z-index: 9;
}

.border-item {
  border: #9c9c9c 1px solid;
  border-radius: 5px;
}
.tab-note {
  margin-bottom: 16px;
  margin-top: 10px !important;
  background: #fbfbfb;
  padding-top: 0 !important;
}

.book-calendar {
  height: 31px;
  align-items: center;
  background: #f7f7fc;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

.block-booking {
  .booking-time {
    color: #333333;
    font-weight: 500;
    font-size: 12px;
    line-height: 20px;
  }

  .bookign-type {
    color: #bdbdbd;
    font-weight: normal;
    font-size: 10px;
    line-height: 20px;
  }
}

.table-pre {
  text-align: left;
  margin-left: 24px;
}

.tab-action-teacher {
  .v-tabs {
    margin-bottom: 30px !important;
  }
}

.showEdit {
  width: 200px;
  position: absolute;
  background: #ffffff;
  z-index: 999;
  right: 24px;
  border: 1px solid #cbd4db;
  box-shadow: 0px 10px 15px 0px #0000000f;

  .v-list-item {
    font-size: 13px;

    &:hover {
      .v-icon {
        opacity: 1;
        margin-right: 10px;
      }
    }

    .v-icon {
      margin-right: 10px;
      opacity: 0;
    }
  }
}
.icon-tab {
  object-fit: cover;
  width: 34px;
  height: 34px;
  margin-right: 8px;
}

.icon {
  margin-right: 32px;
  vertical-align: middle;
}

.down {
  -moz-transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg);
}

.table-layout .v-data-table__wrapper thead th {
  position: sticky;
  top: 0px;
  z-index: 9;
}

.border-item {
  border: #9c9c9c 1px solid;
  border-radius: 5px;
}
.border-order {
  border-bottom: #9c9c9c 1px solid;
  border-radius: 5px;
}
.down {
  -moz-transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg);
}
.create-note{
  padding-top: 0!important;
}
.transfers-order {
    background: #F1F7FF;
    margin: 16px 16px 26px 32px;
    border-radius: 6px;
    padding: 12px;
    .transfers-order-name {
    color: black;
    font-weight: 700;
    text-align: left;
    span {
        color: #828282;
        }
    }
    .transfers-order-info {
        display: flex;
        width: 100%;
        text-align: left;
        .transfers-order-item {
            color: #6A2C62;
            font-weight: 700;
            width: 50%;
            span {
                color: #333333;
            }
        }
        .transfers-order-icon {
            width: 23px;
            height: 23px;
            text-align: center;
            background: #6A2C62;
        }
    }
}
</style>
<style lang="scss">
#style-1::-webkit-scrollbar-track
{
	-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
	border-radius: 10px;
	background-color: #F5F5F5;
}

#style-1::-webkit-scrollbar
{
	width: 6px;
	background-color: #F5F5F5;
}

#style-1::-webkit-scrollbar-thumb
{
	border-radius: 10px;
	-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
	background-color: #999999;
}
.table-layout.custome-style {
  .v-data-table__wrapper {
    overflow-y: auto !important;
  }
  .v-data-table__wrapper::-webkit-scrollbar-track
  {
    -webkit-box-shadow: inset 0 0 6px #999999;
    border-radius: 10px;
    background-color: #F5F5F5;
  }
  .v-data-table__wrapper::-webkit-scrollbar
  {
    width: 6px;
    height: 6px;
    background-color: #F5F5F5;
  }

  .v-data-table__wrapper::-webkit-scrollbar-thumb
  {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px #999999;
    background-color: #999999;
  }
}
.table-overflow > .v-data-table__wrapper{
  max-height: 400px!important;
  overflow: auto!important;
  table{
    padding: 0 10px;
    table-layout: fixed;

    thead tr{
      position: sticky;
      top: 0;
      background: white;
      z-index: 10;
    }
  }
}
.level-sort{
  background: linear-gradient(147.14deg, #FF3B3B 6.95%, #6600CC 93.05%);
  border-radius: 100px;
  width: 78px;
  height: 16px;
  justify-content: center;
  display: flex;
  align-items: center;
  color: #FFFFFF;
  white-space: nowrap;
  padding: 0 4px;
}
.deposit {
  background: #268A42 ;
  color: white;
  border-radius: 3px;
  font-weight: bold;
  width: 65px
}
.deposit.finished {
  background: #6A2C62;
}
.create-finish-order-btn {
  display: inline-block;
  padding: 0px 15px;
  background: #2F80ED;
  border-radius: 3px;
  color: white;
  font-weight: bold;
  cursor: pointer;
}
.log-deposit {
    display: flex;
}
.log-deposit-status {
    width: 85px;
}
.log-deposit-info {
    display: flex;
    width: calc(100% - 85px);
    justify-content: space-between;
    margin-right: 28px;
}
.sticky-right {
  position: sticky;
  right: 0;
  z-index: 10 !important;
  background-color: white;
}
.sticky-left {
  position: sticky;
  left: 0;
  z-index: 10 !important;
  background-color: white;
}
.history-support tr:hover td {
  background: #e0e0e0 !important;
}
.ticket-status-box {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px 8px;
  border-radius: 5px;
  width: fit-content;
}
.receipt-status-box {
  min-width: 105px;
  color: white;
  width: fit-content;
  padding: 0px 12px;
  border-radius: 4px;
  font-size: 12px;
  line-height: 2;
  white-space: nowrap;
}
.receipt-status-box.success {
  background: #279600;
}
.receipt-status-box.primary {
  background-color: #184BFF !important;
}
</style>
